var keyMirror = require("keymirror");

module.exports = keyMirror({
	ADD_INTEGRATION_CUSTOMIZE: null,
	EDIT_INTEGRATION_CUSTOMIZE: null,
	DELETE_INTEGRATION_CUSTOMIZE: null,
	GET_INTEGRATION_CUSTOMIZE: null,
	UPDATE_IMAGE_ASSETS: null,
	GET_IMAGE_ASSETS: null,
	UPDATE_IMAGE_SETTINGS: null,
	DELETE_IMAGE_ASSET: null,
});
